import React from 'react';
import { motion } from 'framer-motion';

const categories = [
  {
    id: 'programming',
    title: '🖥️ Programming',
    items: [
      { label: 'Python Automation', desc: 'CLI tool generating Home Assistant configs – cuts setup time by 50%.' },
      { label: 'GodotSkript Scripting', desc: 'In-engine scripts for Godot plugins enabling dynamic tools.' },
    ],
  },
{
  id: 'ai',
  title: '🤖 AI',
  items: [
    { label: 'Self-Hosted Models', desc: 'Llama3 & Whisper on one-GPU server for dev & experiments.' },
    { label: 'AI-Assisted Java', desc: 'Use AI to scaffold and optimize Java code snippets in mods.' },
  ],
},
{
  id: 'modding',
  title: '🎮 Minecraft Modding',
  items: [
    { label: 'Java Mods', desc: 'Custom enchantments & health indicators on Fabric & Quilt.', badge: 'fabric_vector.svg' },
    { label: 'Open-Source', desc: 'GitHub repos with CI/CD pipelines.', badge: 'github_vector.svg' },
  ],
},
{
  id: 'electronics',
  title: '🔌 ESP32 & PCBs',
  items: [
    { label: 'Standalone Firmware', desc: 'ESP32 C++ & MicroPython with OTA updates for each device.' },
    { label: 'PCB Design', desc: 'KiCad schematics and hand-soldered SMD boards.' },
  ],
},
{
  id: 'smarthome',
  title: '🏠 Smart Home',
  items: [
    { label: 'Home Assistant', desc: 'Voice routines & sensor automations – ESP32 modules independent.' },
    { label: 'Integrations', desc: 'Node-RED flows & custom MQTT automations for lights & climate.' },
  ],
},
{
  id: 'arch',
  title: '🐧 Arch & Networking',
  items: [
    { label: 'Arch Expert', desc: 'Dotfiles with Ansible; optimized tiling WM for productivity.', badge: 'archlinux_vector.svg' },
    { label: 'DHCP Networks', desc: 'Maintain DHCP-based home networks serving 40+ devices.' },
  ],
},
{
  id: 'selfhosting',
  title: '🛠️ Proxmox & Self-Hosting',
  items: [
    { label: 'Home Assistant', desc: 'Open-source home automation platform for IoT control.' },
    { label: 'Heimdall', desc: 'Dashboard for organizing all your app & service links.' },
    { label: 'Kasm Workspaces', desc: 'Containerized browser/desktop streaming via web interfaces.' },
    { label: 'Vaultwarden', desc: 'Self-hosted Bitwarden-compatible password manager.' },
    { label: 'SearXNG', desc: 'Privacy-respecting metasearch engine.' },
    { label: 'Wazuh', desc: 'Open-source security monitoring (XDR & SIEM) platform.' },
    { label: 'Nextcloud', desc: 'Self-hosted content collaboration: files, calendars, and more.' },
    { label: 'Apache Guacamole', desc: 'HTML5 remote desktop gateway – access machines in browser.' },
    { label: 'Peppermint OS', desc: 'Lightweight Linux VM template for Proxmox.' },
  ],
},
];

const container = {
  hidden: { opacity: 1 },
  show: { transition: { staggerChildren: 0.15 } },
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0 },
};

export default function Projects() {
  return (
    <motion.section
    className="glass section"
    id="projects"
    variants={container}
    initial="hidden"
    animate="show"
    style={{ padding: '2rem' }}
    >
    <h2>Projects & Hobbies</h2>
    {categories.map((cat) => (
      <motion.div key={cat.id} variants={item} style={{ marginBottom: '2rem' }}>
      <h3 id={cat.id}>{cat.title}</h3>
      <ul style={{ listStyle: 'none', padding: 0 }}>
      {cat.items.map((it, i) => (
        <motion.li
        key={i}
        variants={item}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          marginBottom: '0.5rem',
        }}
        >
        {it.badge && (
          <img
          src={`https://cdn.jsdelivr.net/npm/@intergrav/devins-badges@3/assets/cozy/available/${it.badge}`}
          alt={`${it.label} badge`}
          style={{ width: 24, height: 24 }}
          loading="lazy"
          />
        )}
        <div>
        <strong>{it.label}:</strong> {it.desc}
        </div>
        </motion.li>
      ))}
      </ul>
      </motion.div>
    ))}
    </motion.section>
  );
}
